const QuoteService = {
  async get() {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };

    return await fetch(`${process.env.VUE_APP_API_URL}quotes`, { headers });
  },

  async save(data) {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    return await fetch(`${process.env.VUE_APP_API_URL}quotes`, {
      method: "POST",
      body: JSON.stringify(data),
      headers,
    });
  },

  async getById(id) {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    return await fetch(`${process.env.VUE_APP_API_URL}quotes/${id}`, {
      headers,
    });
  },
};

export default QuoteService;
